export default "__VITE_ASSET__3190184f__"